const STATUS_STYLES: Record<string, string> = {
  ACTIVE: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  INACTIVE: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  TERMINATED: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300',
  RESIGNED: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
  RETIRED: 'bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-300',
};

export function EmploymentStatusBadge({ status }: { status?: string }) {
  const value = (status ?? 'ACTIVE').toUpperCase();
  const style = STATUS_STYLES[value] ?? STATUS_STYLES.INACTIVE;
  return (
    <span className={`rounded px-2 py-0.5 text-xs font-medium ${style}`}>
      {value.replace(/_/g, ' ')}
    </span>
  );
}
